import { FC } from 'react';
import { StepDto } from '../../../../../../dtos';
import { SmartValueListItem } from './SmartValueSlice';
import { WYSIWYGInputField } from './WYSIWYGInputField';

export interface IWYSIWYGDescriptionProps {
    fieldErrors: Map<keyof StepDto, string>;
    description: string;
    handleDescriptionChange: (value: string) => void;
    smartValues: SmartValueListItem[];
}

export const WYSIWYGDescription: FC<IWYSIWYGDescriptionProps> = ({ fieldErrors, description, handleDescriptionChange, smartValues }) => {
    return (
        <WYSIWYGInputField
            label='Description'
            tooltip='Whatever you write here will show up on the emails I send to your job function members.'
            errorMessage={fieldErrors.get('description')}
            value={description}
            handleValueChange={handleDescriptionChange}
            dataReferences={smartValues.map((sv) => sv.value)}
        />
    );
};
